import { TableColumn } from "react-data-table-component";
import { TooltipCell } from "src/components/Tooltip/TooltipCell";
import { TicketFieldSetting } from "src/sdk/models/Organisation";
import { Ticket } from "src/sdk/models/Ticket";

export const TicketingColumns = (
  fields: TicketFieldSetting[],
  handleDetailsClick: (ticket: Ticket) => void,
): TableColumn<Ticket>[] => {
  console.log(fields)
  const dynamicColumns: TableColumn<Ticket>[] = fields
    .filter(f => f.showOnList)
    .map(f => ({
      id: f.filedKey ?? f.name, 
      name: <TooltipCell>{f.label}</TooltipCell>,
      sortable: f.sortable,
      sortField: f.filedKey ?? undefined,
      cell: (row: any) => (<TooltipCell>{row[f.name] ?? "-"}</TooltipCell>)
    }));

  dynamicColumns.push({
    name: <span>Actions</span>,
    cell: (row: Ticket) => (
      <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
        <button
          style={{
            backgroundColor: "#95CBB2",
            color: "#FFFFFF",
            border: 0,
            borderRadius: 60,
            width: 120,
            padding: "10px 25px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14
          }}
          onClick={() => handleDetailsClick(row)}
        >
          <i className="bi bi-list" style={{ marginRight: 6 }} />
          Details
        </button>
      </div>
    ),
    width: "140px",
    ignoreRowClick: true,
    allowOverflow: true,
    button: true
  });

  return dynamicColumns;
};
